import { TextKey } from '@mews-commander/enums';
import { LocalizedPageTitle, PortfolioLayout, PortfolioLayoutHeader } from '@mews-commander/ui';
import { QueueItemsTable } from './EnterpriseBuilderQueueItems/QueueItemsTable';

export const EnterpriseBuilderProQueueItemsView = () => (
    <PortfolioLayout>
        <PortfolioLayoutHeader title={<LocalizedPageTitle textKey={TextKey.EnterpriseBuilderProQueueItemPlural} />} />
        <QueueItemsTable />
    </PortfolioLayout>
);
